<template>
  <div class="button__wrapper">
    <div v-if="!disabled" class="add_button_wrapper">
      <el-button
        icon="el-icon-plus"
        type="primary"
        size="small"
        @click="open"
        plain
        >{{ $l('btn_add_Button_Info') || '添加功能按钮信息' }}</el-button
      >
    </div>
    <vxe-grid
      ref="buttonFunctionTable"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      height="350"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:opt="{ row, rowIndex }">
        <el-dropdown trigger="click" @command="chooseFunction">
          <i class="el-icon-arrow-down el-icon--right"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              icon="el-icon-edit"
              :command="{
                pageType: 'edit',
                row: row,
                rowIndex: rowIndex,
              }"
              :disabled="disabled"
              >{{ $l('INDEX.btn_tips_edit') || '编辑' }}</el-dropdown-item
            >
            <el-dropdown-item
              icon="el-icon-delete"
              :command="{
                pageType: 'del',
                row: row,
                rowIndex: rowIndex,
              }"
              :disabled="disabled"
              divided
              >{{ $l('INDEX.btn_tips_del') || '删除' }}</el-dropdown-item
            >
            <el-dropdown-item
              icon="el-icon-refresh"
              :command="{
                pageType: 'changeBtnId',
                row: row,
                rowIndex: rowIndex,
              }"
              :disabled="disabled"
              divided
              >{{ $l('btn_change_btn_id') || '更改按钮编号' }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </template>
      <template v-slot:isVisible="{ row }">
        <el-tag
          size="mini"
          :type="
            row.isVisible === 'Y'
              ? 'success'
              : row.isVisible === 'N'
              ? 'warning'
              : ''
          "
        >
          {{ row.v_isVisible }}
        </el-tag>
      </template>
      <template v-slot:buttonImage="{ row }">
        {{ row.buttonImage }}
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      :title="
        rowIndex >= 0
          ? $l('dialog_title_update_button_info') || '修改功能按钮信息'
          : $l('dialog_title_add_button_info') || '添加功能按钮信息'
      "
      :show-close="true"
      :visible.sync="addButtonInfpDialogVisible"
      width="800px"
      v-if="addButtonInfpDialogVisible"
      :close-on-click-modal="false"
      append-to-body
      destroy-on-close
    >
      <el-form
        ref="form"
        :model="buttonForm"
        label-width="140px"
        size="small"
        :rules="rules"
      >
        <el-row :gutter="10" class="mb10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_isVisible') || '是否可见'"
              prop="isVisible"
            >
              <el-radio-group v-model="buttonForm.isVisible">
                <el-radio label="Y">{{
                  $l('form_label_isVisible_Y') || '是'
                }}</el-radio>
                <el-radio label="N">{{
                  $l('form_label_isVisible_N') || '否'
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_textVisible') || '按钮文字是否可见'"
              prop="textVisible"
            >
              <el-radio-group v-model="buttonForm.textVisible">
                <el-radio label="Y">{{
                  $l('form_label_isVisible_Y') || '是'
                }}</el-radio>
                <el-radio label="N">{{
                  $l('form_label_isVisible_N') || '否'
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="mb10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_funcID') || '功能编号'"
              prop="funcID"
            >
              <el-input
                v-model="buttonForm.funcID"
                clearable
                size="small"
                :disabled="isAdd"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_buttonID') || '按钮编号'"
              prop="buttonID"
            >
              <el-input
                v-model="buttonForm.buttonID"
                clearable
                size="small"
                :disabled="disabled || !isNew"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="mb10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_eventName') || '按钮对应事件'"
              prop="eventName"
            >
              <el-input v-model="buttonForm.eventName" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_displayText') || '按钮显示文字'"
              prop="displayText"
            >
              <el-input v-model="buttonForm.displayText" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="mb10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_enText') || '英文名称'"
              prop="enText"
            >
              <el-input v-model="buttonForm.enText" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_buttonImage') || '按钮颜色及图片'"
            >
              <el-input v-model="buttonForm.buttonImage" clearable size="small">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="mb10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_modalsPageName') || '按钮位置页面'"
            >
              <el-input
                v-model="buttonForm.modalsPageName"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_sortOrder') || '按钮顺序'"
              prop="sortOrder"
            >
              <el-input-number
                clearable
                v-model="buttonForm.sortOrder"
                style="width: 100%"
                :placeholder="$l('INDEX.tips_input_placeholder') || '排列顺序'"
                size="small"
                :min="0"
                :max="100000000"
              >
              </el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">{{
          $l('INDEX.btn_cancel_query') || '取消'
        }}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="isChangeBtnId ? changeButtonInfo() : addButtonInfo()"
          >{{ $l('INDEX.btn_rep_save') || '保存' }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
const BaseForm = {
  isVisible: 'Y',
  textVisible: 'Y',
  v_isVisible: '是',
  v_textVisible: '是',
}
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    formData: {
      default: () => {},
      type: Object,
    },
    tablePage: {
      default: null,
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isAdd: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    formData: {
      handler(newVal) {
        if (newVal && newVal.funcID) {
          this.buttonForm['funcID'] = newVal.funcID
          BaseForm['funcID'] = newVal.funcID
        }
      },
      immediate: true,
      deep: true,
    },
    'buttonForm.textVisible': {
      handler(newVal) {
        if (newVal && newVal == 'Y') {
          this.buttonForm['v_textVisible'] = '是'
        } else {
          this.buttonForm['v_textVisible'] = '否'
        }
      },
      immediate: true,
      deep: true,
    },
    'buttonForm.isVisible': {
      handler(newVal) {
        if (newVal && newVal == 'Y') {
          this.buttonForm['v_isVisible'] = '是'
        } else {
          this.buttonForm['v_isVisible'] = '否'
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
      addButtonInfpDialogVisible: false,
      buttonForm: {
        ...BaseForm,
      },
      removeList: [],
      rowIndex: -1,
      isNew: false,
      isChangeBtnId: false,
      rules: {
        funcID: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        buttonID: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        eventName: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        displayText: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        isVisible: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        sortOrder: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        textVisible: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
        enText: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_placeholder') || '请选择',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    open() {
      this.addButtonInfpDialogVisible = true
      this.isChangeBtnId = false
      this.buttonForm = Object.assign({}, BaseForm)
      this.isNew = true
    },
    close() {
      this.isChangeBtnId = false
      this.addButtonInfpDialogVisible = false
      this.buttonForm = Object.assign({}, BaseForm)
    },
    changeButtonInfo() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loadingOpen()
          this.$api
            .sysMerchantFunctionChangeApi({ ...this.buttonForm })
            .then(() => {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_update_ok') || '保存成功！',
                type: 'success',
              })
              this.buttonForm = Object.assign({}, BaseForm)
              this.addButtonInfpDialogVisible = false
              this.rowIndex = -1
              this.$emit("reload")
              this.loadingClose()
            })
            .catch(() => {
              this.loadingClose()
            })
        }
      })
    },
    addButtonInfo() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.rowIndex >= 0) {
            if (this.tableData[this.rowIndex]._isNew) {
              Object.assign(this.tableData[this.rowIndex], {
                ...this.buttonForm,
                _isNew: true,
              })
            } else {
              Object.assign(this.tableData[this.rowIndex], {
                ...this.buttonForm,
                _isUpdate: true,
              })
            }
          } else {
            this.tableData.push({ ...this.buttonForm, _isNew: true })
          }
          this.buttonForm = Object.assign({}, BaseForm)
          this.addButtonInfpDialogVisible = false
          this.rowIndex = -1
        } else {
          return false
        }
      })
    },
    getReviseButtonInfoList() {
      const reviseData = {
        buttonList: this.tableData,
        delList: this.removeList,
      }
      return reviseData
    },
    chooseFunction({ pageType, row, rowIndex }) {
      switch (pageType) {
        case 'edit':
          this.openEditPage(row, rowIndex)
          break
        case 'del':
          this.del(row, rowIndex)
          break
        case 'changeBtnId':
          this.changeBtnId(row, rowIndex)
          break
        default:
          return
      }
    },
    changeBtnId(row, rowIndex) {
      this.isChangeBtnId = true
      this.buttonForm = Object.assign({}, this.tableData[rowIndex])
      this.buttonForm.oldButtonID = this.buttonForm.buttonID
      this.addButtonInfpDialogVisible = true
      this.isNew = true
      this.rowIndex = rowIndex
    },
    openEditPage(row, rowIndex) {
      this.buttonForm = Object.assign({}, this.tableData[rowIndex])
      this.addButtonInfpDialogVisible = true
      this.isNew = this.tableData[rowIndex]._isNew
      this.rowIndex = rowIndex
      this.isChangeBtnId = false
    },
    del(row, rowIndex) {
      console.log(row, rowIndex)
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.tableData.splice(rowIndex, 1)
        this.removeList.push({ ...row, _isDel: true })
      })
    },
  },
}
</script>
<style scoped>
.button__wrapper {
  margin-top: 15px;
}
.add_button_wrapper {
  margin-bottom: 10px;
}
.mb10 {
  margin-bottom: 10px;
}
</style>
